import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  initialFormData,
  MasterFormDataType,
  MasterTableDataType,
} from "./types";
import usePopup from "../../../hooks/usePopup";
import { useMutation } from "react-query";
import {  saveMasterData } from "./services";
import { useEffect } from "react";
import {
  Paper,
  Typography,
  Button,
  CircularProgress,
  Divider,
} from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { clinicId, } from "../../../constants";
import useAuthentication from "@hooks/useAuthentication";

const pageTitle = "Loinc ";
function AddOrEditLoinc() {
  const navigate = useNavigate();
  const { user } = useAuthentication();
  const { control, handleSubmit, reset } = useForm<MasterFormDataType>({
    defaultValues: initialFormData,
  });
  
  const {
    state: { data = null },
  } = useLocation() as { state: { data: MasterTableDataType } };
  const { showSnackbar } = usePopup();
  const handleGoBack = () => {
    navigate(-1);
  };
  const { mutate: save, isLoading } = useMutation(saveMasterData, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        handleGoBack();
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message:
          e?.response?.data?.responseMessage ||
          e?.response?.data?.errorMessage ||
          "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });
  const onSubmit = (value: MasterFormDataType) => {
    save([
      {
        clinicId:clinicId,
        value:value?.value,
        code:value?.code,
        name:value?.name,
        status:value?.status,
        createdById:Number(user?.userId),
        loincId: data?.loincId ? data?.loincId : null,
      },
    ]);
  };

  const handleReset = () => {
    reset(initialFormData);
  };

  useEffect(() => {
    if (data) {
      reset({
       code:data?.loincCode,
       name:data?.loincName,
       status:data?.loincStatus?1:0,
       value:data?.loincValue
      });
    }
  }, [data]);

  return (
    <div className="p-3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                {data ? "Update" : "Add"} {pageTitle}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                disabled={isLoading}
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
              >
                back
              </Button>
              {!Boolean(data) && (
                <Button
                  disabled={isLoading}
                  color="error"
                  type="reset"
                  onClick={handleReset}
                  startIcon={<CloseIcon />}
                >
                  reset
                </Button>
              )}
              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <SaveIcon />
                  )
                }
              >
                {data ? "update" : "save"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-3">
            <CustomFormField
              control={control}
              name="code"
              element="input"
              fieldProps={{ label: "Enter loinc code " }}
              rules={{ required: "Code is required" }}
            />
            <CustomFormField
              control={control}
              name="name"
              element="input"
              fieldProps={{ label: "Enter loinc name " }}
              rules={{ required: "Name is required" }}
            />
            <CustomFormField
              control={control}
              name="value"
              element="input"
              fieldProps={{ label: "Enter loinc value " }}
              rules={{ required: "Value is required" }}
            />
           
            <CustomFormField
              control={control}
              name="status"
              element="radio"
              radioProps={{ row: true }}
              radios={[
                { label: "Active", value: 1 },
                { label: "Inactive", value: 0 },
              ]}
              fieldProps={{ label: "Status " }}
              rules={{ required: "Status is required" }}
            />
          </div>
        </Paper>
      </form>
    </div>
  );
}

export default AddOrEditLoinc;
